import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import { useDiscountFormHandling } from "./components/DiscountStateHandle";
import MaterialButton from "../../../components/MaterialButton";
import { useEffect, useState } from "react";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import { setCircleLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";
import DropDownConfig from "../../Utils/DropDownConfig";

const InsurerDiscountForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSnackbar } = useSnackbar();
    const discountId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" 
    ? "edit" : "add";
    const [generalInsurerOptions, setGeneralInsurerOptions] = useState([]);
    const [generalDiscountOptions, setGeneralDiscountOptions] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [policyTypeOptions, setPolicyTypeOptions] = useState([]);

    const { formData, setFormData, handleChange, checkAllFields } = useDiscountFormHandling();  

    useEffect(() => {
        if (pageMode === "add" || !discountId) {
            return;
        }
        //Fetch data by Pincode Id
        const fetchDiscountById = async (discountId) => {
            try {
            const response = await fetchDataById(`/reference/insurer/discount/${discountId}`);

            const responseData = response?.data?.discount;
            
            if (response.success) {
                const mapped = {
                    name: responseData?.name || "",
                    code: responseData?.code || "",
                    gDiscount: {label: responseData?.gDiscountName, value: responseData?.gDiscountId},
                    gInsurer: {label: responseData?.gInsurerName, value: responseData?.gInsurerId},
                    gProduct: {label: responseData?.gProductName, value: responseData?.gProductId},
                    gPolicyType: {label: responseData?.gPolicyTypeName, value: responseData?.gPolicyTypeId},
                    isActive: responseData?.isActive,
                    // reset status fields
                    nameStatus: responseData?.name ? "success" : "unchecked",
                    codeStatus: responseData?.code ? "success" : "unchecked",
                    gDiscountStatus: responseData?.gDiscountId ? "success" : "unchecked",
                    gInsurerStatus: responseData?.gInsurerId ? "success" : "unchecked",
                    gProductStatus: responseData?.gProductId ? "success" : "unchecked",
                    gPolicyTypeStatus: responseData?.gPolicyTypeId ? "success" : "unchecked"

                };

                setFormData(mapped);  
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);
            showSnackbar(error?.response?.data?.message || "Network Error","error");
            }
        };
        fetchDiscountById(discountId);
    }, [pageMode]);

    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchAllDropdowns();
    }, []);

    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);
        try {
            const [
            insurerResponse,
            discountResponse,
            productResponse,
            policyTypeResponse,
            ] = await Promise.all([
            fetchData(`/reference/general/insurer-master?dropdown=true&isActive=true`),
            fetchData(`/reference/general/discount?dropdown=true&isActive=true`),
            fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalProduct}`),
            fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalPolicyType}`),
            ]);

            const formattedInsurers = insurerResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.companyName,
            })) || [];

            const formattedDiscounts = discountResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.name,
            })) || [];


            const formattedProducts = productResponse?.data?.items?.map((item) => ({
                label: item?.keyName,
                value: item?.id,
            })) || [];

            const formattedPolicyTypes = policyTypeResponse?.data?.items?.map((item) => ({
                label: item?.keyName,
                value: item?.id,
            })) || [];
            
            setGeneralInsurerOptions(formattedInsurers);
            setGeneralDiscountOptions(formattedDiscounts);
            setProductOptions(formattedProducts);
            setPolicyTypeOptions(formattedPolicyTypes);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error fetching dropdown data","warning");
        } finally {
            setCircleLoading(false);
        }
    };
    
    const handleSubmitDiscount = async () => {
        const payload = {
            gInsurerId: formData?.gInsurer?.value,
            gDiscountId: formData?.gDiscount?.value,
            name: formData?.name,
            code: formData?.code,
            gProductId: formData?.gProduct?.value,
            gPolicyTypeId: formData?.gPolicyType?.value,
            isActive: formData?.isActive
        };
        //Update
        if(discountId){
            try {
                const response = await putData(`/reference/insurer/discount/${discountId}`, payload);
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage,"success");
                    navigate('/insurer-master/insurer-discount');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage,"error");
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message || "Error Updating Discount","error");
            }
        }
        else{      
        //Submit
        try {
            const response = await postData('/reference/insurer/discount', payload);
            const responseMessage = response?.message;
            if(response?.success){
                //success message
                showSnackbar(responseMessage,"success");
                navigate('/insurer-master/insurer-discount');          
            }
            else{
                //error message
                showSnackbar(responseMessage,"error")
            }
        } catch (error) {
            console.error('Error posting data:', error);
            showSnackbar(error?.response?.data?.message || "Error submitting Discount","error");
            //catch error message
        }
        }
    };

  return (
    <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
            <CardHeader
            title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton onClick={() => navigate("/insurer-master/insurer-discount")}>
                            <ArrowBack />
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Insurer Discount Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="text">
                            Enter New Discount Details to Insurer.
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            )}
            />
            <CardContent>
                <Grid2 container spacing={2}>                                   
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Insurer*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gInsurer"
                        value={formData.gInsurer}
                        onChange={handleChange}
                        options={generalInsurerOptions}
                        success={formData.gInsurerStatus === "success"}
                        error={formData.gInsurerStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Discount*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gDiscount"
                        value={formData.gDiscount}
                        onChange={handleChange}
                        options={generalDiscountOptions}
                        success={formData.gDiscountStatus === "success"}
                        error={formData.gDiscountStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Discount Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        placeholder="eg. Diwali"
                        value={formData.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Discount Name should be a minimum 1 character & maximum 100
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Discount Code*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="code"
                        placeholder="eg. DISC2026"
                        value={formData.code}
                        onChange={handleChange}
                        success={formData.codeStatus === "success"}
                        error={formData.codeStatus === "error"}
                        disabled={pageMode === "view"}
                        />
                        {formData.codeStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Discount Code should be a minimum 1 character & maximum 20
                                characters long.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Product*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gProduct"
                        value={formData.gProduct}
                        onChange={handleChange}
                        options={productOptions}
                        success={formData.gProductStatus === "success"}
                        error={formData.gProductStatus === "error"}
                        isDisabled={pageMode === "view"}
                        menuPlacement="top"
                        />
                    </Grid2>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                General Policy Type*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialSelect
                        name="gPolicyType"
                        value={formData.gPolicyType}
                        onChange={handleChange}
                        options={policyTypeOptions}
                        success={formData.gPolicyTypeStatus === "success"}
                        error={formData.gPolicyTypeStatus === "error"}
                        isDisabled={pageMode === "view"}
                        menuPlacement="top"
                        />
                    </Grid2>
                    <Grid2 size={{lg:2, md:2, sm: 3, xs: 3 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Active
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.isActive}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "isActive",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.isActive ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
            <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            >
                {pageMode !== "view" && (
                <>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="outlined"
                    color="dark"
                    onClick={() => navigate("/insurer-master/insurer-discount")}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    disabled={!checkAllFields()}
                    onClick={handleSubmitDiscount}
                    >
                    {pageMode === "edit" ? "Update" : "Submit"}
                    </MaterialButton>
                </>
                )}
            </MaterialBox>
        </Card>
    </DashboardLayout>
  )
}

export default InsurerDiscountForm